export default function() {

  if ($('.generating-adverse-indicators-message').length > 0) {

    // Start screens status poll if importing
    let adverseIndicatorsStatusPoll = () => {

      // Get generating message on page
      let isGenerating = $('.generating-adverse-indicators-message');

      // Only continue if status indicator present (if should poll for recs is true)
      if (isGenerating.length !== 0) {

        // Set Api url to get data
        let accountUrl = isGenerating.attr('data-account-url');
        let portfolioId = isGenerating.attr('data-portfolio-id');
        let token = isGenerating.attr('data-token');
        let params = {};
        params['portfolio_id'] = portfolioId;
        params['token'] = token;
        let url = '/' + accountUrl + '/portfolios/' + portfolioId + '/adverse_indicators/poll_snapshot.js?' + $.param(params);

        // Execute ajax request (using js erb template to render content so can control profile styling more easily)
        // Must specify '.js' otherwise processes as JSON
        $.ajax({
          type: "POST",
          dataType: "script",
          timeout: 3000,
          url: url,
          complete() {
            setTimeout(function() { adverseIndicatorsStatusPoll() }, 4000);
          }
        });
      }
    };

    // Poll server for status of mapped items, if generating message present
    if ($('.generating-adverse-indicators-message').length !== 0) { adverseIndicatorsStatusPoll(); }

  }

}